var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"component"},[(_vm.label)?_c('label',{domProps:{"innerHTML":_vm._s(_vm.label)}}):_vm._e(),_c('input',{ref:"fileInput",staticClass:"form-control file-input",attrs:{"type":"file","id":_vm.id,"accept":_vm.accept},on:{"input":_vm.onInputChanged}})])
}
var staticRenderFns = []

export { render, staticRenderFns }